/**
 * CommunityGuidelinesSection — renders an org's designated guidelines on its
 * About (alignment) surface. This is the DURABLE HOME the Getting-started
 * "Read this" pointer targets (§7.9 locked rule: acknowledging dismisses the
 * pointer, the material stays reachable here). Renders nothing when the org
 * has no designated guidelines.
 *
 * Collapsed by default (Skip, 2026-07-07): reference material, not hero
 * content — a permanently expanded block dominated the About page. The
 * header toggles; deep-links land here via the #guidelines element id.
 *
 * Authoring is not exposed here yet (pilot orgs seed via SQL; Community
 * Settings authoring is flagged follow-up work).
 */

import React, { useState } from "react";
import { useAppTranslation } from "../../i18n/useAppTranslation";
import { useApiCommunityGuidelines } from "../../api/useApiCommunityGuidelines";
import styles from "./CommunityGuidelinesSection.module.css";

interface Props {
  communityGuid: string;
}

const CommunityGuidelinesSection: React.FC<Props> = ({ communityGuid }) => {
  const { t } = useAppTranslation("pages");
  const { guidelines } = useApiCommunityGuidelines(communityGuid);
  const [expanded, setExpanded] = useState(false);

  if (!guidelines?.content) return null;

  return (
    <section className={styles.panel} id="guidelines">
      <button
        type="button"
        className={styles.header}
        aria-expanded={expanded}
        onClick={() => setExpanded((v) => !v)}
      >
        <span className={styles.title}>{t("communityGuidelines.title")}</span>
        <span className={styles.chevron} aria-hidden="true">
          {expanded ? "▾" : "▸"}
        </span>
      </button>
      {expanded && <div className={styles.content}>{guidelines.content}</div>}
    </section>
  );
};

export default CommunityGuidelinesSection;
